import { z } from "zod";

export const usStateCodeSchema = z.enum([
    "AL",
    "AK",
    "AZ",
    "AR",
    "CA",
    "CO",
    "CT",
    "DE",
    "DC",
    "FL",
    "GA",
    "HI",
    "ID",
    "IL",
    "IN",
    "IA",
    "KS",
    "KY",
    "LA",
    "ME",
    "MD",
    "MA",
    "MI",
    "MN",
    "MS",
    "MO",
    "MT",
    "NE",
    "NV",
    "NH",
    "NJ",
    "NM",
    "NY",
    "NC",
    "ND",
    "OH",
    "OK",
    "OR",
    "PA",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VT",
    "VA",
    "WA",
    "WV",
    "WI",
    "WY",
]);

export const compatibilityProfileSchema = z
    .object({
        housing: z
            .enum(["apartment", "condo", "townhouse", "house"])
            .optional(),
        ownsHome: z.boolean().optional(),
        hasYard: z.boolean().optional(),
        fencedYard: z.boolean().optional(),
        hasOtherDogs: z.boolean().optional(),
        hasCats: z.boolean().optional(),
        hasYoungKids: z.boolean().optional(),
        experiencedOwner: z.boolean().optional(),
        state: usStateCodeSchema.optional(),
    })
    .strict();
